import request from '@/utils/request'
import { collectPages } from '@/utils/ledger'

/**
 * Wallets Management API
 * Base URL: /api/v1/accounting
 */

/**
 * Get all wallets
 * @param {Object} params - Query parameters
 * @param {string} params.status - Filter by status: active|settled|closed
 * @param {number} params.employee_id - Filter by employee ID
 * @param {string} params.sort_by - Sort field: created_at|current_balance|employee_id (default: created_at)
 * @param {string} params.sort_order - Sort order: asc|desc (default: desc)
 * @param {number} params.per_page - Number of items per page (default: 15)
 * @param {number} params.page - Page number (default: 1)
 * @returns {Promise}
 */
export const getWallets = params => request.get('/accounting/wallets', { params })

export const createWallet = data => request.post('/accounting/wallets', data)

/**
 * Get single wallet details
 * @param {number} id - Wallet ID
 * @returns {Promise}
 */
export const getWallet = id => request.get(`/accounting/wallets/${id}`)

/**
 * Get wallet statement with entries for a specific date range
 * @param {number} id - Wallet ID
 * @param {Object} params - Query parameters
 * @param {string} params.date_from - Start date (format: YYYY-MM-DD)
 * @param {string} params.date_to - End date (format: YYYY-MM-DD)
 * @returns {Promise}
 */
export const getWalletStatement = (id, params = {}) => request.get(`/accounting/wallets/${id}/statement`, { params })

export async function fetchAllWallets(params = {}) {
  const perPage = params.per_page || 100
  const first = await getWallets({ ...params, per_page: perPage, page: 1 })
  return collectPages(page => getWallets({ ...params, per_page: perPage, page }), first)
}
